import React, { useState, useEffect } from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  useTranslate,
  useNotify,
  useRedirect,
  required,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { applicationServices } from 'src/services/auth/application/application.service'
import { clientServices } from 'src/services/auth/client/client.service'
import { isJsonValidate } from 'src/helper/validatorJson'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

export const ProcessApplicationCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [clients, setClients] = useState([])
  const [loadingClients, setLoadingClients] = useState(false)
  const [applications, setApplications] = useState([])
  const [loadingApplications, setLoadingApplications] = useState(false)

  useEffect(() => {
    ;(async () => {
      setLoadingClients(true)
      try {
        const allClients = await clientServices.getByAll()
        if (allClients) {
          setClients(allClients)
          setLoadingClients(false)
          return
        }
        notify(`applications not found`, { type: 'error' })
        setLoadingClients(false)
      } catch (error) {
        notify(`please, refresh page`, { type: 'error' })
        setLoadingClients(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getApplicationByClient = async (idClient) => {
    if (idClient) {
      try {
        setLoadingApplications(true)
        let allApplications = await applicationServices.getApplicationByClient(idClient)
        setApplications(allApplications.map((item) => item.application))
        setLoadingApplications(false)
      } catch (error) {
        notify(`applications not found`, { type: 'error' })
        setLoadingApplications(false)
        return
      }
    }
  }

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.processApplication') }
    })
    redirect('/processApplication')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.processApplication') }
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_processApplication')}>
        <SimpleForm>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.endpoint')} required>
              <TextInput source='endpoint' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.client')} required>
              {loadingClients ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='client_id'
                  optionsText={['long_name']}
                  label=''
                  fullWidth
                  options={clients}
                  onChange={(e) => getApplicationByClient(e.target.value)}
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.application')} required>
              {loadingApplications ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  source='application_id'
                  optionsText={['long_name']}
                  options={applications}
                  label=''
                  fullWidth
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.steps')}>
              <TextInput
                source='steps'
                label={false}
                multiline
                rows={5}
                fullWidth
                validate={isJsonValidate}
                format={(v) => {
                  return typeof v === 'object' ? JSON.stringify(v) : v
                }}
                parse={(v) => {
                  try {
                    return (v && v.length >= 2) ? JSON.parse(v) : v
                  } catch (e) {
                    return v || undefined
                  }
                }}
              />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
